export const AVAILABLE = "available";
export const BID = "bid";
export const UNAVAILABLE = "unavailable";
export const NOT_MINTED = "not-minted";
